import { render } from "./UserInfo.vue?vue&type=template&id=10bc943f&scoped=true"
import script from "./UserInfo.vue?vue&type=script&lang=ts"
export * from "./UserInfo.vue?vue&type=script&lang=ts"

import "./UserInfo.vue?vue&type=style&index=0&id=10bc943f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-10bc943f"

export default script